export default __webpack_public_path__ + "static/media/menu31.08d70958.svg";